import React, { useState } from 'react'
import './RangeSliderStyle.css'
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const RangeSlider = ({onChange}) => {
    
    return (
        <div className='ProgressBarwrapper'>
            <Slider min={0} max={5} step={1} onChange={onChange} />
            <div className="numberwrapperproress">
                <div className='numberPoints'>0</div>
                <div className='numberPoints'>1</div>
                <div className='numberPoints'>2</div>
                <div className='numberPoints'>3</div>
                <div className='numberPoints'>4</div>
                <div className='numberPoints'>5</div>
            </div>
        </div>
    )
}
export default RangeSlider